import { ILectioPlugin } from "./Types";

export class PluginDisableAutoUrlDetect implements ILectioPlugin {
	public Init(): void {
		//STM 29571 - vi disabler at IE automatisk konverterer link til a-tags da det ellers giver problems med noten
		CKEDITOR.on('instanceReady', evt => {
			(evt.editor.document.$ as {} as Document).execCommand("AutoUrlDetect", false);
		});
	}
}
